var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityMinor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40647 13.629C7.61137 13.3012 8.04323 13.2015 8.37107 13.4064L12.0001 15.6745L15.6291 13.4064C15.9569 13.2015 16.3888 13.3012 16.5937 13.629C16.7986 13.9568 16.6989 14.3887 16.3711 14.5936L12.3711 17.0936C12.1441 17.2355 11.8561 17.2355 11.6291 17.0936L7.62907 14.5936C7.30124 14.3887 7.20157 13.9568 7.40647 13.629ZM7.40647 10.629C7.61137 10.3012 8.04323 10.2015 8.37107 10.4064L12.0001 12.6745L15.6291 10.4064C15.9569 10.2015 16.3888 10.3012 16.5937 10.629C16.7986 10.9568 16.6989 11.3887 16.3711 11.5936L12.3711 14.0936C12.1441 14.2355 11.8561 14.2355 11.6291 14.0936L7.62907 11.5936C7.30124 11.3887 7.20157 10.9568 7.40647 10.629ZM8.37107 7.40641C8.04323 7.20152 7.61137 7.30118 7.40647 7.62901C7.20158 7.95685 7.30124 8.38871 7.62907 8.59361L11.6291 11.0936C11.8561 11.2355 12.1441 11.2355 12.3711 11.0936L16.3711 8.59361C16.6989 8.38871 16.7986 7.95685 16.5937 7.62901C16.3888 7.30118 15.9569 7.20152 15.6291 7.40641L12.0001 9.67454L8.37107 7.40641Z",
    fill: "#22B44B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityMinor);
export default __webpack_public_path__ + "static/media/priority-minor.42eaf851426604d5667a79b05f3c62e9.svg";
export { ForwardRef as ReactComponent };